import moment from "moment";
import getAvatarUrl from "./get-avatar-url";
import { DATE_FORMATS } from "../constants";

const { DATE_PICKER_FORMAT } = DATE_FORMATS;

export const formatNumber = (number, currency = "usd") => {
  const formatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency.toUpperCase(),
  });
  return formatter.format(number);
};

export const formatStripeDate = (date, format = DATE_PICKER_FORMAT) => {
  const dateMoment = moment.unix(date);
  return dateMoment.format(format);
};

const FormatSub = function formatSubscriber(sub) {
  /** formatting dates */
  const created_date = moment.unix(sub.created);
  const created = created_date.format(DATE_PICKER_FORMAT);

  const current_period_start_date = moment.unix(sub.current_period_start);
  const current_period_start =
    current_period_start_date.format(DATE_PICKER_FORMAT);

  const current_period_end_date = moment.unix(sub.current_period_end);
  const current_period_end = current_period_end_date.format(DATE_PICKER_FORMAT);

  /** formatting the plan text */
  let plan = Object.assign({}, sub.plan);
  plan.interval = sub.plan
    ? plan.nickname
      ? plan.nickname
      : plan.interval === "month"
      ? "Monthly"
      : "Annual"
    : "";

  /** formatting the avatar url */
  let customer_avatar = Object.assign({}, sub.customer_avatar);
  customer_avatar.url = getAvatarUrl({
    name: sub.customer_name,
    avatar: sub.customer_avatar,
  });

  const canceled = sub.status === "canceled" || !!sub.cancel_at_period_end;

  /** adding/overwritting the mapped obj with the formatted fields */
  return Object.assign({}, sub, {
    created,
    current_period_start,
    current_period_end,
    current_period_end_date,
    plan,
    customer_avatar,
    canceled,
  });
};

export default FormatSub;
